import {Typography} from '@logistics-frontend/blocks'
import React from 'react'

import {PerformerBadgeAction} from 'src/api/cargo-c2c'
import defaultPhotoSrc from 'src/assets/person.svg'

import {ActionButton} from '../action-button'
import * as classes from './styles'

type Props = {
  action: PerformerBadgeAction
}

export function PerformerBadge({action}: Props) {
  const performer = action.performer || {}
  const {photo_url: photoUrl, rating} = performer
  const name = performer.short_name || performer.name

  return (
    <ActionButton
      badge={
        rating && (
          <Typography className={classes.rating} group="loose" thickness="medium" variant="caption1">
            {rating}
          </Typography>
        )
      }
      lead={
        photoUrl ? (
          <img alt={name} className={classes.avatar} src={photoUrl} />
        ) : (
          <img alt={name} src={defaultPhotoSrc} />
        )
      }
      title={name}
    />
  )
}
